module.exports = __webpack_public_path__ + "media/reskin-images/icon--upload-image-ad905b36.svg";